import styled, { keyframes } from "styled-components";
import { BASIC_WHITE, BASIC_YELLOW } from "../constants/colors";

export default function IconSpinner() {
  return (
    <SpinningIcon
      xmlns="http://www.w3.org/2000/svg"
      width="100"
      height="100"
      viewBox="0 0 108 109"
    >
      <g
        id="Group_4169"
        data-name="Group 4169"
        transform="translate(-128.5 -314.5)"
      >
        <circle
          id="Ellipse_58"
          data-name="Ellipse 58"
          cx="50"
          cy="50"
          r="50"
          transform="translate(132.5 319.5)"
          fill="none"
          stroke={BASIC_WHITE}
          strokeWidth="2"
        />
        <path
          id="Path_359"
          data-name="Path 359"
          d="M100.5,50.5a50,50,0,1,1-50-50"
          transform="translate(132 318.001)"
          fill="none"
          stroke={BASIC_YELLOW}
          strokeMiterlimit="10"
          strokeWidth="2"
        />
      </g>
    </SpinningIcon>
  );
}

// Keyframe for the spinning animation
const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const SpinningIcon = styled.svg`
  animation: ${spin} 1s linear infinite;
`;
